// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Download } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { downloadCsv } from "@/features/assistant/table-csv";
import type { AnswerTable as AnswerTableData } from "@/features/assistant/types";

export function AnswerTable({ table }: { table: AnswerTableData }) {
  const { t } = useTranslation();
  return (
    <div className="mb-2">
      <Button type="button" variant="outline" size="sm" className="mb-1" onClick={() => downloadCsv(table)}>
        <Download className="h-4 w-4" />
        {t("assistant.downloadCsv")}
      </Button>
      <div className="overflow-x-auto rounded-lg border">
        <table className="w-full text-xs">
          <thead className="bg-muted/60">
            <tr>
              {table.columns.map((column, i) => (
                <th key={i} className="px-2 py-1.5 text-left font-medium text-muted-foreground">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((row, r) => (
              <tr key={r} className="border-t">
                {row.map((cell, i) => (
                  <td key={i} className="px-2 py-1.5">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
